import Popup from 'reactjs-popup';
import Select from 'react-select'
import 'reactjs-popup/dist/index.css';
import React, { useEffect, useState } from 'react'
import { useAuthState } from '../../../../../../Helper/Context';
import { useDispatch } from 'react-redux';
import moment from 'moment'
import { STPMachineryOperationPostDataAPI } from '../../../../../../Redux/STPDashboardSlice/STPPreventiveWork/STPPreventiveMachineryOperationSlice';

export default function STPMachineryOperationDataPopup(props) {

    const { handleOnCloseClick, open, Flag, handleIsPost, rowData, } = props

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails.user
    const dispatch = useDispatch()

    const [MachineryOperationTextField, setMachineryOperationTextField] = useState({
        // readingDate: Flag === 'Update' ? moment(rowData.readingDate).format("YYYY-MM-DD") : '',
        unitType: Flag === 'Update' ? rowData.unitType : '',
        equipmentType: Flag === 'Update' ? rowData.equipmentType : '',
        equipmentDetails: Flag === 'Update' ? rowData.equipmentDetails : '',
        operationHours: Flag === 'Update' ? rowData.operationHours : '',
        currentAmp: Flag === 'Update' ? rowData.currentAmp : '',
    })

    const handleMachineryOperationTextField = (e) => {
        setMachineryOperationTextField({ ...MachineryOperationTextField, [e.target.name]: e.target.value })
    }

    const handlePost = () => {
        const data = {
            T_STP_MachineryOperationID: Flag === 'Update' ? rowData.t_stP_MachineryOperationID : '0',
            OperationHours: MachineryOperationTextField.operationHours,
            CurrentAmp: MachineryOperationTextField.currentAmp,
            M_UserID: UserID,
            token: token,
            handleIsPost: handleIsPost,
            handleOnCloseClick: handleOnCloseClick,
        }
        dispatch(STPMachineryOperationPostDataAPI({ data }))
    }


    return (

        <Popup
            open={open} closeOnDocumentClick={false} onClose={handleOnCloseClick}
        >
            <div className="location_mob_pop modal-dialog modal-dialog-scrollable modal-xl" style={{ alignItems: "center", justifyContent: 'center' }}>
                <div className="modal-content road_ward_modal">
                    <div className="modal-header pl-4 p-1">
                        <h4 className="modal-title" id="staticBackdropLabel">Machinery Operation</h4>
                        <button onClick={handleOnCloseClick} className="btn-close m-1 mr-3" type="button" />
                    </div>
                    <div className="modal-body">
                        <div className='inner-modal-body'>
                            <div className="row details-row">
                                <div className="col-12 col-lg-6">
                                    <div className="form-group">
                                        <label className="d-block" htmlFor="NameofDepartment"><b>Unit Type</b></label>
                                        <input type="text"
                                            className="form-control"
                                            id="unitType"
                                            name='unitType'
                                            value={MachineryOperationTextField.unitType}
                                            onChange={(e) => handleMachineryOperationTextField(e)}
                                            disabled
                                        />

                                    </div>
                                </div>
                                <div className="col-md-6 col-lg-6">
                                    <div className="form-group">
                                        <label className="d-block" htmlFor="NameofDepartment"><b>Equipment Type</b></label>
                                        <input type="text"
                                            className="form-control"
                                            id="equipmentType"
                                            name='equipmentType'
                                            value={MachineryOperationTextField.equipmentType}
                                            onChange={(e) => handleMachineryOperationTextField(e)}
                                            disabled
                                        />

                                    </div>
                                </div>
                                <div className="col-12 col-lg-6">
                                    <div className="form-group">
                                        <label className="d-block" htmlFor="NameofDepartment"><b>Equipment Details</b></label>
                                        <input type="text"
                                            className="form-control"
                                            id="equipmentDetails"
                                            name='equipmentDetails'
                                            value={MachineryOperationTextField.equipmentDetails}
                                            onChange={(e) => handleMachineryOperationTextField(e)}
                                            disabled
                                        />

                                    </div>
                                </div>
                                <div className="col-12 col-lg-6">
                                    <div className="form-group">
                                        <label className="d-block" htmlFor="NameofDepartment"><b>Operation Hours</b></label>
                                        <input type="text"
                                            className="form-control"
                                            id="operationHours"
                                            name='operationHours'
                                            value={MachineryOperationTextField.operationHours}
                                            onChange={(e) => handleMachineryOperationTextField(e)}
                                        />

                                    </div>
                                </div>
                                <div className="col-12 col-lg-6">
                                    <div className="form-group">
                                        <label className="d-block" htmlFor="NameofDepartment"><b>Current Amp</b></label>
                                        <input type="text"
                                            className="form-control"
                                            id="currentAmp"
                                            name='currentAmp'
                                            value={MachineryOperationTextField.currentAmp}
                                            onChange={(e) => handleMachineryOperationTextField(e)}
                                        />

                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-lg-12 pt-lg-5 pt-md-4 pt-3">
                                <div className="btn-action d-flex justify-content-end">
                                    <button type='button'
                                        className="btn allBtn  float-right submit_btn"
                                        onClick={() => handlePost()}
                                        disabled={
                                            MachineryOperationTextField.unitType == '' || MachineryOperationTextField.equipmentType == '' ||
                                            MachineryOperationTextField.equipmentDetails == '' || MachineryOperationTextField.operationHours == '' ||
                                            MachineryOperationTextField.currentAmp == ''
                                        }
                                    >{Flag === "Update" ? "Update" : "Save"} </button>
                                    <button typtton type="button" className="btn addBtns cancel_btn ms-2 mr-2 mx-2  float-right" onClick={handleOnCloseClick} >Cancel</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* )} */}
        </Popup>
    )

}